import { ArrowRight } from 'lucide-react'
import { Button } from '@components/ui/button'

const Suggestion = ({ text, onClick }) => (
  <Button
    variant="outline"
    onClick={onClick}
    className="sm:w-fit w-full min-h-fit bg-muted shrink-0 flex text-left leading-normal justify-between items-start px-3 py-2 rounded-lg border-transparent hover:bg-muted/80 hover:cursor-pointer border-2">
    <div className="whitespace-normal break-words flex-1 mr-2">{text}</div>
    <ArrowRight className="h-5 w-5 ml-1 shrink-0 mt-1" />
  </Button>
)

export default Suggestion
